var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-96 max-w-full pl-2 pr-2"},[_c('img',{staticClass:"w-full",attrs:{"src":"/images/brand_logos.png","alt":"Visa, MasterCard, JCB, AMEX, DinersClub"}})])
}]

export { render, staticRenderFns }